<template>
    <section class="page-banner bg-blue rel z-1">
        <div class="container">
            <div class="banner-inner">
                <h1 class="page-title wow fadeInUp delay-0-2s">404</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb wow fadeInUp delay-0-4s">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active">404 Page Not Found</li>
                    </ol>
                </nav>
            </div>
        </div>
    </section>
    <section class="about-page-section rel z-1 pt-80 rpt-100 pb-80">
        <div class="container">
            <div class="error-content">
                <img src="../../assets/images/404.png">
                <h3>SORRY! PAGE NOT FOUND</h3>
                <p>We can't find that page! The page you are looking for was never existed.</p>
                <div class="col-lg-12 mt-4 text-center">
                    <router-link href="javascript:;" to="/" class="theme-btn style-three">Go to Homepage <i class="fas fa-arrow-right"></i></router-link>
                </div>
               
            </div>
        </div>
    </section>
</template>
<script>


    export default {
        name: 'ErrorPage',

        data() {
            return {
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

        }
    }

</script>